import { render, staticRenderFns } from "./ReorderProfile.vue?vue&type=template&id=2c0af569&scoped=true&"
import script from "./ReorderProfile.vue?vue&type=script&lang=ts&"
export * from "./ReorderProfile.vue?vue&type=script&lang=ts&"
import style0 from "./ReorderProfile.vue?vue&type=style&index=0&id=2c0af569&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0af569",
  null
  
)

export default component.exports